import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState, IThunkContext } from '../../../shared/types/redux';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();

  const dependencies: IThunkContext = {
    config,
    httpApi,
    logger,
  };

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, true, dependencies);
}
